// extracted by mini-css-extract-plugin
export default {"submit-button--disabled":"mAZF70It--SubmitButton_submit-button--disabled__cRK0n","submitButtonDisabled":"mAZF70It--SubmitButton_submit-button--disabled__cRK0n"};